module.exports = __webpack_public_path__ + "img/delay_1.4ae6dfc2.svg";